<template>
  <div style="margin-top: -10px;">
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="待处理" name="audit">
        <ProtocolManageAuditTable ref="auditTable" />
      </el-tab-pane>

      <el-tab-pane label="协议列表" name="todo">
        <ProtocolManageTable ref="todoTable" />
      </el-tab-pane>

      <el-tab-pane label="退/补款协议" name="rollback">
        <RefundProtocolTable ref="rollbackTable" :active="activeName" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ProtocolManageTable from "./ProtocolManageTable";
import ProtocolManageAuditTable from "./ProtocolManageAuditTable";
import RefundProtocolTable from "../refund/RefundProtocolTable";

export default {
  components: {
    ProtocolManageTable,
    ProtocolManageAuditTable,
    RefundProtocolTable,
  },
  data() {
    return {
      activeName: "audit",
    };
  },
  methods: {
    handleTabClick(tab) {
      console.log("tab=====",tab)
      if (tab.name === 'audit') {
        this.$refs.auditTable.loadData()
      }else if (tab.name === 'todo') {
        this.$refs.todoTable.loadData()
      }else if (tab.name === 'rollback') {
        this.$refs.rollbackTable.loadData()
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "src/common/common";
</style>



// WEBPACK FOOTER //
// src/pages/protocol/manage/ProtocolManageTab.vue